// extracted by mini-css-extract-plugin
export default {"panelHeader":"PanelHeader_panelHeader__1oOm4","selected":"PanelHeader_selected__fB2dv"};